export const treatmentFr = {
  "Soins": "Soins",
  "Prothese": "Prothese",
  "Soins gencive": "Soins gencive",
  "Soins pediatre": "Soins pediatre",
  "Soins de bouche": "Soins de bouche",
  "Conservateur": "Conservative",
  "Type": "Type",

  // Server Side 
  "Le traitement deja existe": "Le traitement deja existe",
  "Le nom du traitement est obligatoire": "Le nom du traitement est obligatoire",
  "Le type du traitement est obligatoire": "Le type du traitement est obligatoire",
  "Le prix du traitement est obligatoire": "Le prix du traitement est obligatoire",

  "Traitement deja assuré": "Traitement deja assuré",
  


}